import { createPartnerGeofence } from './createPartnerGeofence';
import { deletePartnerGeofence } from './deletePartnerGeofence';
import { fetchPartnerGeofences } from './fetchPartnerGeofences';
import { validatePartnerGeofence } from './validatePartnerGeofence';

export const partnerGeofenceService = {
  createPartnerGeofence,
  deletePartnerGeofence,
  fetchPartnerGeofences,
  validatePartnerGeofence,
};
